import "./style.css";
import data from "@data/living.json";
import PageInSequence from "@page_templates/PageInSequence";

export default class Living extends PageInSequence {
  static selector = ".living";

  constructor(block) {
    super(block, data);
  }

  onReady() {}

  onComplete = () => {};

  onResize() {}

  onDestroy() {}
}
